import { render } from "./Illustrate.vue?vue&type=template&id=1b0b1a15&bindings={\"message\":\"data\"}"
import script from "./Illustrate.vue?vue&type=script&lang=js"
export * from "./Illustrate.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Illustrate.vue?vue&type=style&index=0&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script